export class MenuItems {
	constructor(private readonly items: [string, JSX.Element][], private currentName: string) {}

	public loopBack() {
		const newIndex =
			(this.items.findIndex(([name]) => name === this.currentName) + this.items.length - 1) %
			this.items.length;
		this.currentName = this.items[newIndex][0];
		return this.items[newIndex];
	}

	public loopForward() {
		const newIndex =
			(this.items.findIndex(([name]) => name === this.currentName) + 1) % this.items.length;
		this.currentName = this.items[newIndex][0];
		return this.items[newIndex];
	}
}
